/** Design System — z-index scale. Single source for stacking order. */
export const zIndex = {
  base: 0,
  raised: 1,
  sticky: 1100,
  dropdown: 1200,
  drawer: 1250,
  modal: 1300,
  toast: 1400,
  tooltip: 1500,
} as const;

export type ZIndex = typeof zIndex;
